<template>
  <div class="appRepair" :style="{ width: width, height: height }">
    <van-nav-bar>
      <template #left>
        <img src="../../assets/appRepair/title-logo.png" class="title-logo" alt="">
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="imgs">
        <img class="repair-btn" src="../../assets/appRepair/repair-repeat.png" alt="" @click="goTo('appRepairApplication')">
        <img class="search-btn" src="../../assets/appRepair/search-repeat.png" alt="" @click="goTo('appRepairSearch')">
      </div>
      <div class="contact">
        <img class="contact-logo" src="../../assets/appRepair/contact.png" alt="">
        <div class="contact-text">
          <div class="contact-inner-describe">服务热线</div>
          <a class="contact-inner-phone" href="tel:400-921-9595">400-921-9595</a>
        </div>
      </div>
    </div>
    <div class="bottom-logo"></div>
    <div class="bottom-text">上海杰宝大王智能信息技术有限公司</div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'AppRepair',
  components: {},
  data() {
    return {
      width: '0',
      height: '0',
      contentHeight: '0',
      queryId: ''
    }
  },
  created() {
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id
    }
    this.getBrowserInterfaceSize()
  },
  mounted() {
    this.getBrowserInterfaceSize()
  },
  methods: {
    goTo(url) {
      if (url === 'appRepairApplication') {
        console.log(this.queryId)
        if (this.queryId) {
          this.$router.push('/' + url + '?id=' + this.queryId)
        } else {
          Toast.fail('请通过扫码进入该页面')
        }
      } else {
        if (this.queryId) {
          this.$router.push('/' + url + '?queryId=' + this.queryId)
        } else {
          this.$router.push('/' + url)
        }
      }
    },
    getBrowserInterfaceSize() {
      var pageWidth = window.innerWidth
      var pageHeight = window.innerHeight
      if (typeof pageWidth !== 'number') {
        // 在标准模式下面
        if (document.compatMode === 'CSS1Compat') {
          pageWidth = document.documentElement.clientWidth
          pageHeight = document.documentElement.clientHeight
        } else {
          pageWidth = document.body.clientWidth
          pageHeight = window.body.clientHeight
        }
      }
      this.width = pageWidth + 'px'
      this.height = pageHeight + 'px'
      this.contentHeight = this.height - 46 + 'px'
    }
  }
}
</script>

<style scoped lang='scss'>
.appRepair {
  background-color: #f5f5f5;
  .title-logo {
    width: 14.0625rem;
    height: 1.75rem;
  }
  .content{
    width: 100%;
    padding: .625rem 1.25rem;
    height: calc(100% - 46px - 5.9375rem);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .imgs{
      height:74%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    img{
      border-radius: .625rem;
      margin: 0 auto;
      width: 100%;
      &:active{
        opacity: .7;
        transform: translate(.125rem,.125rem);
        -ms-transform: translate(.125rem,.125rem);
        -moz-transform: translate(.125rem,.125rem);
        -webkit-transform: translate(.125rem,.125rem);
        -o-transform: translate(.125rem,.125rem);
      }
    }
    .repair-btn{
      box-shadow: 0 0 1.25rem #2facf5;
    }
       .search-btn{
      box-shadow: 0 0 1.25rem #809DFF;
    }
    .contact{
      display: flex;
      align-items: center;
      .contact-logo{
        width: 8.75rem;
        margin-right: 1.5625rem;
      }
      .contact-text{
        .contact-inner-describe{
          font-size: .8125rem;
          font-family: 微软雅黑;
          color: #4E5C8F;
        }
        .contact-inner-phone{
          font-size: 1.25rem;
          font-family: 微软雅黑;
          color: #346AE6;
        }
      }
    }

  }
  .bottom-logo {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 18.3125rem;
    height: 5.9375rem;
    background: url("../../assets/appRepair/bottom-logo.png") no-repeat;
    background-size: 100% 100%;
  }
  .bottom-text{
    position: fixed;
    left: 0;
    bottom: .6875rem;
    width: 100%;
    text-align: center;
    font-size: .875rem;
    font-family: 微软雅黑;
    font-weight: 700;
    letter-spacing: .0625rem;
    color: #19036E;
    line-height: 1.5625rem;
  }
}
</style>
